import React, { useEffect, useState } from "react";
import apiClient from "../../api/client";

export default function CompanySelect({ name = "owningCompany", value, onChange, allowAdd = false, label = "חברה מחזיקה", emptyLabel = "— לא משויך —" }) {
  const [companies, setCompanies] = useState([]);

  const load = () => apiClient.get("/companies").then((r) => setCompanies(r.data || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const handle = async (e) => {
    if (allowAdd && e.target.value === "__add__") {
      const newName = window.prompt("שם החברה החדשה:");
      if (!newName || !newName.trim()) return;
      try {
        const res = await apiClient.post("/companies", { name: newName.trim() });
        setCompanies(res.data || []);
        onChange({ target: { name, value: newName.trim() } });
      } catch {
        window.alert("הוספת החברה נכשלה");
      }
      return;
    }
    onChange({ target: { name, value: e.target.value } });
  };

  return (
    <div className="field">
      <label style={{ fontSize: 12, color: "var(--text-secondary)" }}>{label}</label>
      <select className="select" name={name} value={value || ""} onChange={handle}>
        <option value="">{emptyLabel}</option>
        {companies.map((c) => <option key={c} value={c}>{c}</option>)}
        {allowAdd && <option value="__add__">+ חברה חדשה…</option>}
      </select>
    </div>
  );
}
